import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import {  AsideToggleDirective } from './aside.directive';

@NgModule({
  declarations: [
    AsideToggleDirective
  ],
  imports: [
    BrowserModule
  ],
  exports: [
    AsideToggleDirective
  ]
})
export class AsideToggleDirectiveModule {

}




// WEBPACK FOOTER //
// ./src/app/shared/directives/aside/aside.module.ts